import React from 'react';
import { ListChecks } from 'lucide-react';
import PortfolioTab from '../../components/vendor/profile/PortfolioTab';
import { VendorPageHeader, VendorGuideCallout } from '../../components/vendor/guidance';
import { VENDOR_PAGE_GUIDES } from '../../utils/vendorPageGuides';

const VendorPortfolio = () => {
  return (
    <div className="space-y-5">
      <VendorPageHeader
        title="Portfolio"
        subtitle="Showcase your best work on your public profile so clients book with confidence."
      />

      <VendorGuideCallout
        title={VENDOR_PAGE_GUIDES.portfolio.title}
        steps={VENDOR_PAGE_GUIDES.portfolio.steps}
        icon={ListChecks}
      />

      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm p-4 sm:p-6 lg:p-8">
        <PortfolioTab />
      </div>
    </div>
  );
};

export default VendorPortfolio;
